import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "42",
  height: "11",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#1F72CD",
      "fill-rule": "evenodd",
      d: "M4.678 0 0 10.568h5.6l.695-1.685h1.587l.694 1.685h6.164V9.282l.55 1.286h3.188l.55-1.313v1.313h12.82l1.559-1.641 1.46 1.641 6.584.014-4.693-5.268L41.451 0H34.97L33.45 1.61 32.037 0H18.091l-1.198 2.728L15.667 0H10.08v1.242L9.457 0H4.678Zm1.084 1.5h2.73l3.103 7.167V1.501h2.99l2.397 5.138L19.19 1.5h2.975v7.583h-1.81l-.015-5.942-2.64 5.942h-1.62l-2.654-5.942v5.942H9.703l-.707-1.7H5.181l-.704 1.699H2.48L5.761 1.5Zm25.423 0h-7.362v7.58h7.248l2.336-2.512 2.252 2.512h2.353l-3.42-3.768 3.42-3.811h-2.251l-2.325 2.483L31.185 1.5ZM7.09 2.785 5.833 5.812h2.512L7.09 2.784Zm18.55 1.671V3.07h4.594l2.005 2.214-2.093 2.226H25.64V6h4.016V4.454H25.64Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "amex"}) } }